import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';

const OrderButtons = ({ curStatus, curAction, cancelClick, printPackageClick, confirmClick, buttonName, confirmDeliveryClick, roleId, disabled }) => {

  const renderStatusButtons = () => {
    const status = Number(curStatus) || 0;
    const canRender = status > 0 && status <= 6 && status !== 3;
    if (!canRender) return null;
    const canPrint = status <= 4;
    const canConfirm = status <= 2;
    const numericRoleId = Number(roleId);
    const canConfirmDelivery = status === 6 && curAction !== 'confirmed';
    const canCancel = status <= 4 && (numericRoleId === 1 || numericRoleId === 12);

    return (
      <Row>
        {canPrint && (
          <ButtonRow variant="primary" onClick={printPackageClick} text="Print Packing" />
        )}
        {canConfirm && (
          <ButtonRow variant="success" onClick={confirmClick} text={buttonName ?? 'Confirm'} />
        )}
        {canConfirmDelivery && (
          <ButtonRow variant="success" onClick={confirmDeliveryClick} text="Confirm Delivery" />
        )}
        {canCancel && (
          <ButtonRow variant="danger" onClick={cancelClick} text="Cancel Order" />
        )}
      </Row>
    );
  };


  // Helper Component for Status Buttons
  const ButtonRow = ({ variant, onClick, text }) => (
    <Col>
      <Button variant={variant} className="me-2" onClick={onClick} disabled={disabled}>
        {text}
      </Button>
    </Col>
  );

  return (
    <div>
      {renderStatusButtons()}
    </div>
  );
};

export default OrderButtons;